
import React from 'react';
import { Calendar, CreditCard } from 'lucide-react';
import { formatDate } from '@/utils/dateUtils';
import { Subscription } from '@/hooks/useCurrentSubscription';

interface SubscriptionDetailsProps {
  subscription: Subscription;
}

const SubscriptionDetails: React.FC<SubscriptionDetailsProps> = ({ subscription }) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <p className="text-sm text-muted-foreground">Plan actuel</p>
        <p className="font-medium text-lg">{subscription.niveau_compte.niveau}</p>
      </div>
      <div>
        <p className="text-sm text-muted-foreground">Montant mensuel</p>
        <p className="font-medium text-lg">{subscription.montant_total || subscription.niveau_compte.prix}€</p>
      </div>
      <div>
        <p className="text-sm text-muted-foreground">Date de début</p>
        <div className="flex items-center">
          <Calendar className="h-4 w-4 mr-1 text-muted-foreground" />
          <p className="font-medium">{formatDate(subscription.date_debut)}</p>
        </div>
      </div>
      <div>
        <p className="text-sm text-muted-foreground">Prochain renouvellement</p>
        <div className="flex items-center">
          <CreditCard className="h-4 w-4 mr-1 text-muted-foreground" />
          <p className="font-medium">{subscription.date_fin ? formatDate(subscription.date_fin) : 'Automatique'}</p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionDetails;
